import { Icon } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import { SIGNUP_STEPS_DIRECT_UK } from '../../constants';
import { useSignupRouterUK } from '../../hooks/useSignupRouter/useSignupRouterUK';
import { TSignupStepsUK } from '../../types';
import { Button } from '../Button/Button';

const BackToStep = () => {
  const { navigateSignupWithoutStateUpdate, currentStep } = useSignupRouterUK();

  const getPreviousStep = (currentStep: string): TSignupStepsUK => {
    const currentStepIndex = SIGNUP_STEPS_DIRECT_UK.findIndex(
      (step) => step === currentStep,
    );

    if (currentStepIndex > 0) {
      return SIGNUP_STEPS_DIRECT_UK[currentStepIndex - 1];
    }

    return '';
  };

  if (currentStep === 'new') return null;

  return (
    <Button
      size="small"
      variant="tertiary"
      onClick={() =>
        navigateSignupWithoutStateUpdate(getPreviousStep(currentStep))
      }
    >
      <Icon icon="angleLeft" /> <Trans>Back to step</Trans>
    </Button>
  );
};

export default BackToStep;
